import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class ElevationComponent extends Component {
  static readonly TYPE_ID: string = '01085a9cfe7f4f4ca36e58f7ffc67a6b';

  constructor(
    public readonly elevation: number,
  ) {
    super();
  }

  get $typeId() {
    return ElevationComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  static fromMap(context: SerializationContext, map: SerializedData): ElevationComponent {
    return new ElevationComponent(
        MapUtils.get<number>(map, 'elevation'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'elevation': this.elevation,
    };
  }

  clone(): this {
    return new ElevationComponent(
        this.elevation,
    ) as this;
  }

  isSame(other: ElevationComponent): boolean {
    if(this === other) {
      return true;
    }

    return other.elevation === this.elevation;
  }
}

export class ElevationComponentBuilder extends DataModelBuilder<ElevationComponent> {
  build(context: SerializationContext, map: SerializedData): ElevationComponent {
    return ElevationComponent.fromMap(context, map);
  }
}
